/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import CustomButton, {
  BtnRadius,
  BtnSizes,
  BtnTypes,
} from "../../../lib/CustomButton";
import SvgLikeContained from "../../../pages-components/blog-pages/bolg-details-page/details-helper/comments/comments-helpers/svgs/SvgLikeContained";
import SvgLikeOutlined from "../../../pages-components/blog-pages/bolg-details-page/details-helper/comments/comments-helpers/svgs/SvgLikeOutlined";
import { numAsString } from "@/utils/functions/functions";
import { useTranslation } from "@/hooks/localization/useTranslations";
import SvgDislikeContained from "../../../pages-components/blog-pages/bolg-details-page/details-helper/comments/comments-helpers/svgs/SvgDislikeContained";
import SvgDislikeOutLined from "../../../pages-components/blog-pages/bolg-details-page/details-helper/comments/comments-helpers/svgs/SvgDislikeOutLined";
import { IReview } from "@/api/AppApi/services/reviews/interfaces";
import {
  useSubmitToggleUnusefulQuery,
  useSubmitToggleUsefulQuery,
} from "@/api/AppApi/services/reviews";
import Attachments from "./helpers/Attachments/Attachments";
import ProductStars from "../../product-details-rate/ProductStars";
import { isSignedInAtom } from "@/hooks/authAtoms";
import { useAtom } from "jotai";
import SvgEdit from "@/app/components/pages-components/checkout/checkout-icons/SvgEdit";
import usePopup from "@/hooks/usePopup";
import { submitproductReviewPopupAtoms } from "@/hooks/headerHooks";
interface props extends IReview {
  product_id: number | string;
  onClickAction: () => void;
}
const ProductReviewCard: React.FC<props> = ({
  likes,
  dislikes,
  reaction,
  id,
  created_at,
  customer,
  comment,
  rating,
  attachments,
  onClickAction,
  can_edit,
  product_id,
}) => {
  const t = useTranslation();
  const [isSignedIn] = useAtom(isSignedInAtom);
  const [commentReaction, setReaction] = useState(reaction);
  const toggleUsefulQuery = useSubmitToggleUsefulQuery({
    onError: (_err) =>{},
    onSuccess: () => {
      onClickAction();
    },
  });
  const toggleUnusefulQuery = useSubmitToggleUnusefulQuery({
    onError: (_err) => {},
    onSuccess: () => {
      onClickAction();
    },
  });
  const { handleOpenPopup } = usePopup(submitproductReviewPopupAtoms);
  return (
    <div className="product-review-card">
      <div className="reviewer">
        <ProductStars small rate={rating} />
        <div className=" d-flex gap-2">
          <p className="m-0">{`by ${customer.name}, ${created_at}`}</p>
          {can_edit && (
            <SvgEdit
              dim={16}
              onClick={() =>
                handleOpenPopup({
                  product_id,
                  initialValues: {
                    review_id: id,
                    rating,
                    comment,
                    attachments: attachments.map(
                      (attachment) => attachment.value,
                    ),
                  },
                })
              }
            />
          )}
        </div>
      </div>
      <p className="m-0">{comment}</p>
      <div>
        <Attachments attachments={attachments} />
      </div>
      {isSignedIn && (
        <div className="like-btns">
          <CustomButton
            onClick={() => {
              setReaction((commentReaction) =>
                commentReaction === "liked" ? null : "liked",
              );
              toggleUsefulQuery.mutate({ reviewId: id });
            }}
            type={
              commentReaction === "liked"
                ? BtnTypes.primary
                : BtnTypes?.primary_not_selected_like
            }
            size={BtnSizes.semi_small}
            radius={BtnRadius.semi_small}
          >
            <div>
              {commentReaction === "liked" ? (
                <>
                  <SvgLikeContained /> {t.liked} {`(${numAsString(likes)})`}
                </>
              ) : (
                <>
                  <SvgLikeOutlined /> {t.like} {`(${numAsString(likes)})`}
                </>
              )}
            </div>
          </CustomButton>
          <CustomButton
            onClick={() => {
              setReaction((commentReaction) =>
                commentReaction === "disliked" ? null : "disliked",
              );
              toggleUnusefulQuery.mutate({ reviewId: id });
            }}
            type={
              commentReaction === "disliked"
                ? BtnTypes.primary
                : BtnTypes?.primary_not_selected_like
            }
            size={BtnSizes.semi_small}
            radius={BtnRadius.semi_small}
          >
            <div>
              {commentReaction === "disliked" ? (
                <>
                  <SvgDislikeContained /> {t.disliked}
                  {`(${numAsString(dislikes)})`}
                </>
              ) : (
                <>
                  <SvgDislikeOutLined /> {t.dislike}
                  {`(${numAsString(dislikes)})`}
                </>
              )}
            </div>
          </CustomButton>
        </div>
      )}
    </div>
  );
};

export default ProductReviewCard;
